// Case Detail "Deadlines" tab (SPEC §3.7) — deadlines scoped to one Case. Thin
// wrapper over the shared DeadlinesPanel; passing caseId pre-links new entries to
// this Case and hides the Case column.

import { DeadlinesPanel } from "../DeadlinesPanel";

export function CaseDeadlinesTab({ caseId }: { caseId: number }): JSX.Element {
  return <DeadlinesPanel caseId={caseId} />;
}
